import { Breakpoint, useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";
import { useContentSize } from "../../main/content/ContentSizeContext";

// The 7 status KPI cards fit one row only when the content area is widest; as the side menu / AI chat shrink it,
// they wrap to fewer equal-width columns. Keyed off the content-area breakpoint (not the viewport) via useContentSize.
const kpiColumnsByBreakpoint: Record<Breakpoint, number> = {
    xl: 7,
    lg: 7,
    md: 4,
    sm: 2,
    xs: 2,
};

export const useRiskMitigationOverviewStyles = () => {
    const theme = useTheme();
    const { breakpoint } = useContentSize();
    return createSxStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            flex: 1,
            gap: theme.spacing(2),
        },
        kpiRow: {
            display: "grid",
            gridTemplateColumns: `repeat(${kpiColumnsByBreakpoint[breakpoint]}, 1fr)`,
            gap: theme.spacing(2),
        },
        kpiCard: {
            paddingX: 3,
            paddingY: 0,
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            minHeight: 125,
            cursor: "pointer",
            transition: "box-shadow 0.15s ease",
            "&:hover": {
                boxShadow: theme.shadows[4],
            },
        },
        kpiCardActive: {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
            "&:hover": {
                boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
            },
        },
        bold: {
            fontWeight: theme.typography.fontWeightBold,
        },
        // Single-line truncation for the free-text columns (action description, scenario name) so a long value
        // doesn't stretch the column; the full text stays available via the cell's tooltip.
        ellipsis: {
            maxWidth: 260,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        nameCell: {
            maxWidth: 260,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.primary.main,
        },
        italic: {
            fontStyle: "italic",
            color: theme.palette.text.secondary,
        },
        muted: {
            color: theme.palette.text.secondary,
        },
    });
};
